export const STORE_LOOKUP = 'STORE_LOOKUP';
export const LOOKUPS_LOADED = 'LOOKUPS_LOADED';
